import { Table, Spinner } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';
import { StatusPill } from './StatusPill';
import { fmtDate, fmtTime, fmtDateTime, summarizeAssignments, personName } from '../Helpers/format';

const EmptyState = ({ icon, title, text }) => (
  <div className="pm-empty" role="status">
    <FeatherIcon icon={icon} size={28} />
    <h6>{title}</h6>
    <p>{text}</p>
  </div>
);

/**
 * Plain reactstrap table; the server already sorts by move-out date desc.
 * Rows are keyboard-focusable and open the detail view.
 */
const PreMoveoutListTable = ({ items = [], loading = false, hasSelection = false, onRowClick }) => {
  const open = (doc) => onRowClick && onRowClick(doc);

  return (
    <div className="pm-table-wrap">
      {!hasSelection ? (
        <EmptyState
          icon="home"
          title="Choose a property"
          text="Select a property and building above to see its pre-moveout inspections."
        />
      ) : loading && !items.length ? (
        <div className="pm-empty" role="status" aria-live="polite">
          <Spinner size="sm" color="primary" className="me-2" />
          Loading inspections…
        </div>
      ) : !items.length ? (
        <EmptyState
          icon="clipboard"
          title="No inspections yet"
          text="Nothing matches the current filters. Use “New inspection” to record the first one."
        />
      ) : (
        <Table hover className="pm-table" aria-busy={loading || undefined}>
          <thead>
            <tr>
              <th scope="col">Unit</th>
              <th scope="col">Move-out</th>
              <th scope="col">Pre-inspection</th>
              <th scope="col">Status</th>
              <th scope="col" className="text-center">
                Repairs
              </th>
              <th scope="col">Vendors</th>
              <th scope="col">Updated</th>
            </tr>
          </thead>
          <tbody>
            {items.map((doc) => {
              const time = fmtTime(doc.moveout_time);
              const vendors = summarizeAssignments(doc.assignments);
              const inspector = personName(doc.inspected_by);
              return (
                <tr
                  key={doc._id}
                  tabIndex={0}
                  role="button"
                  aria-label={`Open inspection for unit ${doc.unit_number || ''}`}
                  onClick={() => open(doc)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      open(doc);
                    }
                  }}
                >
                  <td>
                    <span className="pm-unit">{doc.unit_number || '—'}</span>
                    {inspector && <span className="pm-sub">by {inspector}</span>}
                  </td>
                  <td>
                    {fmtDate(doc.moveout_date)}
                    {time && <span className="pm-sub">{time}</span>}
                  </td>
                  <td>{fmtDate(doc.pre_inspection_date)}</td>
                  <td>
                    <StatusPill status={doc.status} />
                  </td>
                  <td className="text-center">{(doc.repairs || []).length}</td>
                  <td>{vendors || <span className="text-muted">—</span>}</td>
                  <td className="text-muted small">{fmtDateTime(doc.updatedAt)}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export { PreMoveoutListTable };
export default PreMoveoutListTable;
